<template>
  <b-notification :closable="false">
    <em>{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-em-1') }}</em
    >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-1') }}<br />
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-2') }}<br /><br />
    <em>{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-em-2') }}</em
    >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-3') }}<br />{{
      $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-4')
    }}<br />
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-5') }}<br />
    <img
      src="@/assets/images/geshelp/doc_methodecalcul_consohoraire.png"
      style="padding-left: 25px; max-width: 70%"
    />
    <br /><br />
    <em>{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-em-3') }}</em
    >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-6') }}<br />
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-7') }}
    (<a
      class="link"
      target="_blank"
      href="https://vfrg.casa.gov.au/general/conversions/distance-volume-and-mass/"
      >source</a
    >) : 1,39<br />
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-8') }}
    (<a
      class="link"
      target="_blank"
      href="http://www.bp.com.au/products/aviation/news/BPJETA1.PDF"
      >source</a
    >) : 1,25<br /><br />
    {{
      $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-9')
    }}Rindlisbacher, T., Chabbey L., 2015. Guidance on the Determination of
    Helicopter Emissions, Edition 2, Confédération suisse, ref.
    COO.2207.111.2.2015750<br />
    SHP = max SHP * MOPE<br />
    <span style="margin-left: 10px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-1') }}<br
    /></span>
    <span style="margin-left: 10px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-2') }}<br
    /></span>
    <span style="margin-left: 20px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-3') }}<br
    /></span>
    <span style="margin-left: 20px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-4') }}<br
    /></span>
    <span style="margin-left: 20px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-5') }}<br
    /></span>
    <span style="margin-left: 20px"
      >{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-span-6')
      }}<br /><br
    /></span>
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-10') }}<br />
    <pre>Fuel flow &asymp; 1.9*10<sup>-12</sup> * SHP<sup>4</sup> - 10<sup>-9</sup> * SHP<sup>3</sup> + 2.6*10<sup>-7</sup> * SHP<sup>2</sup> + 4*10<sup>-5</sup> * SHP + 6*10<sup>-4</sup></pre>
    {{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-11') }}<br />
    <pre>
{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-pre-1') }}
Fuel flow &asymp; 4.0539*10<sup>-18</sup> * SHP<sup>5</sup> - 3.16298*10<sup>-14</sup> * SHP<sup>4</sup> + 9.2087*10<sup>-11</sup> * SHP<sup>3</sup> -
      1.2156*10<sup>-7</sup> * SHP<sup>2</sup> + 1.1476*10<sup>-4</sup> * SHP + 0.01256
<span v-html="$t('compCarbonFormsVehiclesHelpCalculatingMethod.text-pre-2')" />
Fuel flow &asymp; 3.3158*10<sup>-16</sup> * SHP<sup>5</sup> - 1.01750*10<sup>-12</sup> * SHP<sup>4</sup> + 1.1627*10<sup>-9</sup> * SHP<sup>3</sup> -
      5.9528*10<sup>-7</sup> * SHP<sup>2</sup> + 1.8168*10<sup>-4</sup> * SHP + 6.2945*10<sup>-3</sup>
{{ $t('compCarbonFormsVehiclesHelpCalculatingMethod.text-pre-3') }}
Fuel flow &asymp; 2.1970*10<sup>-15</sup> * SHP<sup>5</sup> - 4.44410*10<sup>-12</sup> * SHP<sup>4</sup> + 3.4208*10<sup>-9</sup> * SHP<sup>3</sup> -
      1.2138*10<sup>-6</sup> * SHP<sup>2</sup> + 2.4140*10<sup>-4</sup> * SHP + 4.583*10<sup>-3</sup></pre>
  </b-notification>
</template>

<script>
export default {
  name: 'HelpCalculatingMethod'
}
</script>
